import React from 'react';
import { Box } from '@mui/material';

import { AngleField, DistanceField } from '@paragon/material';

import { updateShapeDetailsAndRegenerateTruss } from '../../../../../../store/actions/insertComponentDesignActions';
import { ValleyShapeDetails as ValleyShapeDetailsInterface } from '../../../../../../store/slices/applicationSlice';
import { useAppDispatch } from '../../../../../hooks';
import { createExceedsMaxLengthErrorAction, exceedsMaxLength, minTrussLength } from './Length';

const textFieldSx = { m: 1, flex: 1 } as const;

interface Props {
  readonly shapeDetails: ValleyShapeDetailsInterface;
}

export function ValleyShapeDetails({ shapeDetails }: Props) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <DistanceField
          label="Length"
          value={shapeDetails.span}
          min={minTrussLength}
          onSubmit={async (value) => {
            if (exceedsMaxLength(value)) {
              dispatch(createExceedsMaxLengthErrorAction());
              return;
            }

            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, span: value }));
          }}
          sx={textFieldSx}
        />
        <AngleField
          label="Slope"
          sx={textFieldSx}
          value={shapeDetails.slopeInDegrees}
          defaultDisplayFormat="slope"
          onSubmit={async (value) => {
            await dispatch(updateShapeDetailsAndRegenerateTruss({ ...shapeDetails, slopeInDegrees: value }));
          }}
        />
      </Box>
    </>
  );
}
